import React, { Component } from "react";
import themeLarge from "../ThemeLarge";

class HeaderRow extends Component {
  render() {
    const { userEmail, currentTime, onCreateBlog } = this.props;

    return (
      <div className="row my-3">
        {/* User Info */}
        <div className="col-md-4">
          <p
            style={{
              fontFamily: "Kumbh Sans",
              fontSize: themeLarge.fontSize.small,
            }}
          >
            <i>Logged in as {userEmail}</i>
            <br />
            It's now: {currentTime}
          </p>
        </div>

        {/* Create Blog Button */}
        <div className="col-md-8 d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-sm"
            onClick={onCreateBlog}
            style={{
              background: themeLarge.colors.primary,
              fontFamily: "Kumbh Sans",
              fontSize: themeLarge.fontSize.h4,
              color: themeLarge.colors.bg,
              boxShadow: themeLarge.shadows.standard,
              borderRadius: "10px",
              transition: "background-color 1s ease, color 1s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor =
                themeLarge.colors.gradient; // Highlight on hover
              e.currentTarget.style.color = "#000";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = themeLarge.colors.primary; // Revert to original color
              e.currentTarget.style.color = themeLarge.colors.bg;
            }}
          >
            Create new Blog!
          </button>
        </div>
      </div>
    );
  }
}

export default HeaderRow;
